import React from "react";

import {
    Text as RNText,
    TextProps as RNTextProps,
    TextStyle
} from "react-native";
import Fonts from "../../Theme/Fonts";

interface TextProps extends RNTextProps {
    type?: "super_hero_title" | "normal";
}

const Text = (props: TextProps) => {

    const { type = "normal", style, children, ...restProps } = props;

    let superHeroTitleStyle: TextStyle = {};
    if (type === "super_hero_title") {
        superHeroTitleStyle = {fontFamily: Fonts.superHero.bold }
    }

    return <RNText style={[ superHeroTitleStyle, style ]} {...restProps}>
        {children}
    </RNText>
}

export default Text;